import { Link } from "react-router-dom";
import { ArrowRight, Check, AlertCircle } from "lucide-react";
import { BRAND } from "@/lib/brand";
import { GUIDE } from "@/lib/guide";
import { ThemeToggle } from "@/components/ThemeToggle";

export default function Guide() {
  return (
    <div className="min-h-screen" style={{ background: "var(--bg)", color: "var(--text-primary)" }} data-testid="guide-page">
      <header className="px-6 md:px-12 py-7 flex items-center justify-between">
        <Link to="/" className="flex items-baseline gap-2" data-testid="guide-logo">
          <span className="font-script" style={{ fontSize: "1.75rem" }}>{BRAND.name}</span>
          <span className="wordmark-tag" style={{ color: "var(--accent)" }}>{BRAND.tag}</span>
        </Link>
        <ThemeToggle />
      </header>

      <main className="max-w-[820px] mx-auto px-6 md:px-12 pb-32">
        <section className="pt-16 pb-14 text-center">
          <p className="overline">{GUIDE.eyebrow}</p>
          <h1 className="lp-h text-4xl sm:text-5xl lg:text-6xl mt-8 leading-[1.1]">{GUIDE.title}</h1>
          <div className="bronze-rule mx-auto mt-10" />
          <p className="lp-body text-xl mt-8 max-w-xl mx-auto" style={{ color: "var(--text-secondary)" }}>{GUIDE.subtitle}</p>
        </section>

        <p className="lp-body text-lg leading-relaxed" style={{ color: "var(--text-secondary)" }}>{GUIDE.intro}</p>

        <section className="mt-16">
          <p className="overline">Part one</p>
          <h2 className="lp-h text-3xl mt-4">{GUIDE.signsTitle}</h2>
          <div className="mt-8 space-y-5">
            {GUIDE.signs.map((s, i) => (
              <article key={i} className="p-8" style={{ background: "var(--surface-1)", border: "0.5px solid var(--border-strong)" }} data-testid={`guide-sign-${i + 1}`}>
                <div className="flex items-start gap-4">
                  <span className="lp-h text-3xl" style={{ color: "var(--accent)" }}>0{i + 1}</span>
                  <div>
                    <h3 className="font-serif text-xl flex items-center gap-2"><AlertCircle size={15} style={{ color: "var(--accent)" }} /> {s.title}</h3>
                    <p className="lp-body text-base mt-3 leading-relaxed" style={{ color: "var(--text-secondary)" }}>{s.body}</p>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </section>

        <section className="mt-16">
          <p className="overline">Part two</p>
          <h2 className="lp-h text-3xl mt-4">{GUIDE.stepsTitle}</h2>
          <div className="mt-8 space-y-5">
            {GUIDE.steps.map((s, i) => (
              <article key={i} className="p-8" style={{ background: "var(--ink)", color: "#F8F5EF" }} data-testid={`guide-step-${i + 1}`}>
                <h3 className="font-serif text-xl flex items-center gap-3">
                  <Check size={16} style={{ color: "#A89880" }} /> Step {i + 1} — {s.title}
                </h3>
                <p className="lp-body text-base mt-3 leading-relaxed" style={{ color: "#D4CFC7" }}>{s.body}</p>
              </article>
            ))}
          </div>
        </section>

        <section className="mt-20 text-center">
          <div className="bronze-rule mx-auto" />
          <p className="lp-body text-xl mt-10 leading-relaxed" style={{ color: "var(--text-secondary)" }}>{GUIDE.closing}</p>
          <Link to="/apply" className="btn-primary mt-10 inline-flex" data-testid="guide-apply-cta">
            {GUIDE.ctaLabel} <ArrowRight size={12} />
          </Link>
        </section>
      </main>
    </div>
  );
}
